import { render, staticRenderFns } from "./OpenModalButton.vue?vue&type=template&id=2408a8cc&scoped=true"
import script from "./OpenModalButton.vue?vue&type=script&lang=js"
export * from "./OpenModalButton.vue?vue&type=script&lang=js"
import style0 from "./OpenModalButton.vue?vue&type=style&index=0&id=2408a8cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2408a8cc",
  null
  
)

export default component.exports